import { apiFetch } from "@/lib/api/client";

/**
 * Einmaliger Import von Kundendaten aus einer älteren localStorage-basierten
 * Version der App (POST /api/migrations/localstorage). 1:1 aus src/db.js
 * portiert; wird nur nach einem Admin-Login angeboten, wenn der Schlüssel
 * "cleverfleet_clients" noch im Browser existiert.
 */
export async function importLegacyLocalStorage(): Promise<{ imported: number }> {
  const raw = localStorage.getItem("cleverfleet_clients");
  if (!raw) return { imported: 0 };

  const clients = JSON.parse(raw);
  const result = await apiFetch<{ imported: number }>("/migrations/localstorage", {
    method: "POST",
    body: JSON.stringify({ clients })
  });

  localStorage.removeItem("cleverfleet_clients");
  localStorage.removeItem("cleverfleet_logs");
  localStorage.removeItem("cleverfleet_advisors");
  return result;
}
